export class ProjectLanguage {
  constructor(public projectId: string, public languageCode: string, public userId: string) {}

  static fromRow(row: Record<string, any>): ProjectLanguage {
    return new ProjectLanguage(row.project_id, row.language_code, row.user_id);
  }
}

export default ProjectLanguage;
